import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import CertificationsRoutes from "../routes/certifications-routes";
import LoadingComp from "../components/re-usable/loading/loading";
import Footer from "../components/footer/footer";

const CertificationsLayout = () => {
  return (
    <>
      <Suspense fallback={<LoadingComp />}>
        <Routes>
          {CertificationsRoutes.map((route, index) => {
            return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
          })}
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
};

export default CertificationsLayout;
